import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import _get from 'lodash/get';
import _noop from 'lodash/noop';

import COLORS from '@mlb/react-patterns/style/universal.color';
import FONTS from '@mlb/react-patterns/style/fonts';

import { mainCq } from 'bdvp-common/src/styles/helpers/main-cq';

const Container = styled.div`
    margin-top: 20px;
    color: ${COLORS.mlbWhite};
    font-family: ${FONTS.primaryFont};
    font-size: 14px;
    font-style: normal;
    font-stretch: normal;
    font-weight: bold;
    letter-spacing: normal;
    line-height: 1.56;
    ${mainCq.md`
        margin-top: 25px;
    `}
`;

const ListItem = styled.li`
    display: inline-grid;
    margin: 0 10px 10px 0;
`;

// "body &" fixes an issue where basesite overrides color in the "a" tag
const LinkOverride = styled(Link)`
    padding: 8px 12px;
    border-radius: 20px;
    background: ${COLORS.mlbGrey6};
    cursor: pointer;
    text-transform: capitalize;
    body & {
        color: ${COLORS.mlbWhite};
        &:hover {
            color: ${COLORS.mlbWhite};
        }
    }
`;

const Tags = ({
    searchRoute,
    onTagClick,
    mediaPlayback,
}) => {

    const tags = _get(mediaPlayback, 'keywordsDisplay', []);

    if(tags.length < 1) {

        return null;

    }

    const listItems = (
        tags.map((tag, index) => {

            const slug = _get(tag, 'slug', '');
            const displayName = _get(tag, 'displayName', '');

            const url = {
                pathname: searchRoute,
                search: `?q=${encodeURIComponent(`ContentTags = ["${slug}"] Order by Timestamp DESC`)}`,
            };

            const text = slug.includes('gamepk') ? 'More From This Game' : displayName;

            return (
                <ListItem key={index}>
                    <LinkOverride
                        to={url}
                        onClick={(event) => onTagClick(text, url)}
                    >
                        {text}
                    </LinkOverride>
                </ListItem>
            );

        })
    );

    return (
        <Container>
            <ul>
                {listItems}
            </ul>
        </Container>
    );

};

Tags.propTypes = {
    searchRoute: PropTypes.string,
    onTagClick: PropTypes.func,
    mediaPlayback: PropTypes.object,
};

Tags.defaultProps = {
    searchRoute: '/search',
    onTagClick: _noop,
    mediaPlayback: {},
};

export default Tags;
